import type { ECountry } from '@/shared/enum/country.enum'
import { mceProductionUrls, mceStageUrls } from '@/shared/constants/mce-url.constant'
import isStageEnvironment from '@/shared/utils/is-stage-environment'

const getMceUrlByCountry = (country: ECountry): string | undefined => {
  const mceUrls = isStageEnvironment() ? mceStageUrls : mceProductionUrls

  return mceUrls.get(country)
}

export default getMceUrlByCountry
